<template>
    <div class="setting-page-content-wrapper notification-settings">
        <div class="page-header">
            <div class="title">{{ $t("search.allNotificationSettings") }}</div>
            <div class="subtitle">{{ $t("notification.notificationSettingsDesc") }}</div>
        </div>

        <section>
            <a-collapse v-model="activeKeys" :bordered="false" class="notification-collapse">
                <a-collapse-panel
                    v-for="group of groups"
                    :key="group.id"
                    :header="group.title"
                >
                    <BasicActions
                        :settings="settings"
                        @update="updateScopeNotificationSettings"
                        :title="group.title"
                        :allowed-scopes="group.allowedScopes"
                    />
                </a-collapse-panel>
            </a-collapse>
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import BasicActions from "./BasicActions.vue";
import { ACTIVITY_API } from "../../../../../api/activity";

export default Vue.extend({
        name: "NotificationSettings",
    components: { BasicActions },
    data() {
        return {
            loading: false,
            settings: [],
            activeKeys: ["basic"],
            groupDefs: [
                {
                    id: "basic",
                    titleKey: "notification.basicActions",
                    allowedScopes: [
                        "chat-assign",
                        "ticket-assign",
                        // "task-assign",
                        "chat-close-own",
                        "contact-owner",
                    ],
                },
                {
                    id: "supsis-crm",
                    titleKey: "notification.crmActions",
                    allowedScopes: [
                        "tag-actions-to-visitor",
                        "create-ticket",
                        "note-actions-to-visitor",
                        "visitor-profile-updates",
                    ],
                },
                {
                    id: "company",
                    titleKey: "notification.companyActions",
                    allowedScopes: [
                        "chat-start",
                        "department-crud",
                        "settings-crud",
                        "integration-channel-crud",
                        "login-form-crud",
                        "banned-word-crud",
                        "email-account-crud",
                        "prepared-content-crud",
                        "role-crud",
                        "tag-crud",
                        "welcome-message-crud",
                        "webhook-crud",
                        "billing-events",
                        // "task-workflow-crud",
                        // "task-crud",
                        "system-status",
                        "reservation-events",
                        "white-list-events",
                    ],
                },
                {
                    id: "task",
                    titleKey: "message.taskModule",
                    allowedScopes: [
                        "task-crud",
                        "task-created",
                        "task-deleted",
                        "task-workflow-created",
                        "task-workflow-updated",
                        "task-workflow-permanently-deleted",
                        "task-workflow-pipeline-stage-added",
                        "task-workflow-pipeline-stage-updated",
                        "task-workflow-pipeline-stage-deleted",
                        "task-module-rules-enabled",
                        "task-module-rules-disabled",
                        "task-module-rules-rule-added",
                        "task-module-rules-rule-deleted",
                        "task-module-rules-rule-updated",
                        "task-module-rules-rule-enabled",
                        "task-module-rules-rule-disabled",
                        "task-workflow-crud",
                        "task-assign",
                        "task-complet",
                        "task-archive",
                    ],
                },
                {
                    id: "automation",
                    titleKey: "notification.automationActions",
                    allowedScopes: [
                        "automation-created",
                        "automation-deleted",
                        "automation-published",
                        "automation-unpublished",
                        "automation-updated",
                        "automation-task-credit-low",
                        "automation-task-credit-done",
                    ],
                },
                {
                    id: "forms",
                    titleKey: "auto.notificationSettingsGroupForms",
                    allowedScopes: [
                        "form-created-scope",
                        "form-updated-scope",
                        "form-deleted",
                        "form-downloaded-scope",
                        "form-view-limit-low",
                        "form-view-limit-done",
                    ],
                },
                {
                    id: "users",
                    titleKey: "auto.notificationSettingsGroupUsers",
                    allowedScopes: [
                        "user-crud",
                        "user-info-changed-scope",
                    ],
                },
                {
                    id: "roles",
                    titleKey: "auto.notificationSettingsGroupRoles",
                    allowedScopes: [
                        "role-updated",
                    ],
                },
                {
                    id: "drive",
                    titleKey: "auto.notificationSettingsGroupDrive",
                    allowedScopes: [
                        "drive-folder-created",
                        "drive-folder-deleted",
                        "drive-folder-renamed",
                        "drive-file-added",
                        "drive-file-deleted",
                    ],
                },
                {
                    id: "contact-module",
                    titleKey: "auto.notificationSettingsGroupContactModule",
                    allowedScopes: [
                        "contact-module-rules-enabled",
                        "contact-module-rules-disabled",
                        "contact-module-rules-rule-added",
                        "contact-module-rules-rule-updated",
                        "contact-module-rules-rule-deleted",
                        "contact-module-rules-rule-enabled",
                        "contact-module-rules-rule-disabled",
                    ],
                },
                {
                    id: "developer",
                    titleKey: "auto.notificationSettingsGroupDeveloper",
                    allowedScopes: [
                        "developer-token-changed",
                    ],
                },
                {
                    id: "contacts",
                    titleKey: "auto.notificationSettingsGroupContacts",
                    allowedScopes: [
                        "contact-batch-updated",
                        "chat-data-downloaded",
                    ],
                },
                {
                    id: "table",
                    titleKey: "auto.notificationSettingsGroupTables",
                    allowedScopes: [
                        "table-created",
                        "table-deleted",
                        "table-restored",
                        "table-permanently-deleted",
                        "table-field-added",
                        "table-field-updated",
                        "table-field-deleted",
                        "table-view-actions",
                        "table-page-actions",
                        "table-widget-actions",
                        "table-permission-changed",
                        "table-data-downloaded",
                        "table-data-imported",
                        "table-data-batch-updated",
                        "table-data-batch-deleted",
                        "module-created",
                        "module-updated",
                        "module-deleted",
                        "relation-created",
                        "relation-updated",
                    ],
                },
                {
                    id: "web-app",
                    titleKey: "auto.notificationSettingsGroupWebApps",
                    allowedScopes: [
                        "web-app-created",
                        "web-app-updated",
                        "web-app-deleted",
                        "web-tab-created",
                        "web-tab-updated",
                        "web-tab-deleted",
                    ],
                },
                {
                    id: "chatbot",
                    titleKey: "notification.chatbotActions",
                    allowedScopes: [
                        "chatbot-story-crud",
                        "chatbot-forward-chat",
                        "chatbot-user-segment-crud",
                        "chatbot-credit-low",
                        "chatbot-ai-model-updated",
                    ],
                },
                {
                    id: "whatsapp",
                    titleKey: "notification.whatsappActions",
                    allowedScopes: [
                        "whatsapp-credit-low",
                        "whatsapp-customer-group-crud",
                        "whatsapp-broadcast-message-crud",
                        "whatsapp-template-message-crud",
                        "whatsapp-qr-code-status",
                    ],
                },
                {
                    id: "wallet",
                    titleKey: "auto.notificationSettingsGroupWalletAutoTopUp",
                    allowedScopes: [
                        "auto-rebalance-events",
                    ],
                },
                {
                    id: "voice-agent",
                    titleKey: "auto.notificationSettingsGroupVoiceAgents",
                    allowedScopes: [
                        "voice-agent-created",
                        "voice-agent-updated",
                        "voice-agent-deleted",
                        "voice-agent-phone-number-inbound-agent-changed",
                        "voice-agent-phone-number-outbound-agent-changed",
                        "voice-agent-batch-call-created",
                        "voice-agent-knowledge-base-created",
                        "voice-agent-knowledge-base-deleted",
                    ],
                },
                {
                    id: "waba-supsis",
                    titleKey: "auto.notificationSettingsGroupWabaSupsisV2",
                    allowedScopes: ["waba-supsis-partner-remove", "waba-supsis-partner-added", "waba-supsis-account-deleted", "waba-supsis-account-violation", "waba-supsis-ad-account-linked", "waba-supsis-auth-intl-price-eligibility-update", "waba-supsis-disabled-update", "waba-supsis-mm-lite-terms-signed", "waba-supsis-partner-app-installed", "waba-supsis-partner-app-uninstalled", "waba-supsis-partner-client-certification-status-update", "waba-supsis-business-primary-location-country-update", "waba-supsis-volume-based-pricing-tier-update", "waba-supsis-message-template-components-update", "waba-supsis-message-template-status-update", "waba-supsis-template-category-update"],
                },
            ],
        };
    },
    computed: {
        groups() {
            var vm = this;
            return this.groupDefs.map(function (def) {
                return {
                    id: def.id,
                    title: vm.$t(def.titleKey),
                    allowedScopes: def.allowedScopes,
                };
            });
        },
    },
    mounted() {
        this.fetchSettings();
    },
    methods: {
        updateScopeNotificationSettings(item, platform, value) {
            this.settings = this.settings.map((setting) => {
                if (setting.scope === item) {
                    setting[platform] = value;
                }
                return setting;
            });
        },
        fetchSettings() {
            this.loading = true;
            ACTIVITY_API.NOTIFICATION.getMySettings()
                .then((res) => {
                    this.settings = res.data;
                    // Eksik scope'ları ekle
                    const requiredScopes = [
                        "automation-task-credit-low",
                        "automation-task-credit-done",
                        "form-view-limit-low",
                        "form-view-limit-done",
                        "web-app-created", "web-app-updated", "web-app-deleted",
                        "web-tab-created", "web-tab-updated", "web-tab-deleted",
                        "module-created", "module-updated", "module-deleted",
                        "relation-created", "relation-updated",
                        "table-data-downloaded", "table-data-imported", "table-data-batch-updated", "table-data-batch-deleted",
                        "contact-batch-updated", "chat-data-downloaded",
                        "waba-supsis-partner-remove", "waba-supsis-partner-added", "waba-supsis-account-deleted",
                        "waba-supsis-account-violation", "waba-supsis-ad-account-linked",
                        "waba-supsis-auth-intl-price-eligibility-update", "waba-supsis-disabled-update",
                        "waba-supsis-mm-lite-terms-signed", "waba-supsis-partner-app-installed", "waba-supsis-partner-app-uninstalled", "waba-supsis-partner-client-certification-status-update", "waba-supsis-business-primary-location-country-update", "waba-supsis-volume-based-pricing-tier-update", "waba-supsis-message-template-components-update", "waba-supsis-message-template-status-update", "waba-supsis-template-category-update",
                        "chatbot-ai-model-updated"
                    ];
                    requiredScopes.forEach(scope => {
                        if (!this.settings.find(s => s.scope === scope)) {
                            this.settings.push({
                                scope: scope,
                                web: true,
                                mobile: false,
                                email: false
                            });
                        }
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
});
</script>

<style scoped lang="scss">
.notification-settings {
    padding: 10px;
    .page-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        border-bottom: 1px solid var(--color-border-default);
        padding-bottom: 10px;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-default);
        }
    }

    .notification-collapse {
        background: transparent;

        ::v-deep .ant-collapse-item {
            margin-bottom: 12px;
            border: 1px solid var(--color-border-default);
            border-radius: 8px;
            background: var(--color-bg-default);
            overflow: hidden;

            &:last-child {
                margin-bottom: 0;
            }
        }

        ::v-deep .ant-collapse-header {
            font-size: 15px;
            font-weight: 600;
            color: var(--color-text-strong-default);
            padding: 14px 16px 14px 40px !important;
            border-radius: 0 !important;

            &:hover {
                background: var(--color-bg-neutral-subdued-hover);
            }
        }

        ::v-deep .ant-collapse-arrow {
            font-size: 12px !important;
            left: 16px !important;
        }

        ::v-deep .ant-collapse-content {
            border-top: 1px solid var(--color-border-default);

            .ant-collapse-content-box {
                padding: 0;
            }
        }
    }
}
</style>
